import React from 'react';
import { Heart, Facebook, Instagram, Youtube } from 'lucide-react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();



  const quickLinks = [
    { label: 'Início', href: '#inicio' },
    { label: 'Funcionalidades', href: '#funcionalidades' },
    { label: 'Como Funciona', href: '#como-funciona' },
    { label: 'Inscrever-se', href: '#inscrever' }
  ];

  const supportLinks = [
    { label: 'Política de Privacidade', href: '#' },
    { label: 'Termos de Uso', href: '#' },
    { label: 'Dúvidas Frequentes', href: '#' },
    { label: 'Suporte Técnico', href: '#' }
  ];

  const socialLinks = [
    { icon: Facebook, href: '#', label: 'Facebook' },
    { icon: Instagram, href: '#', label: 'Instagram' },
    { icon: Youtube, href: '#', label: 'YouTube' }
  ];

  return (
    <footer className="bg-brown-800 text-white">
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid lg:grid-cols-4 gap-8">
          {/* Brand & Mission */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-4 mb-6">
              <img 
                src="/santogram_logo.png" 
                alt="SantoGram Logo" 
                className="w-16 h-16 md:w-20 md:h-20 object-contain"
              />
              <span className="text-3xl md:text-4xl font-display font-bold">SantoGram</span>
            </div>
            
            <div className="mb-8">
              <h3 className="text-xl font-display font-bold mb-4 text-gold-300">
                Nossa Missão Católica
              </h3>
              <p className="text-brown-200 leading-relaxed mb-4">
                O SantoGram nasceu da missão de evangelizar através da tecnologia, 
                levando a santidade e os ensinamentos da Igreja Católica para o mundo digital. 
                Nosso compromisso é oferecer conteúdo autêntico, baseado na Tradição e no Magistério da Igreja.
              </p>
              <p className="text-brown-200 leading-relaxed">
                "Ide por todo o mundo e pregai o Evangelho a toda criatura." - Marcos 16:15
              </p>
            </div>


          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-display font-semibold mb-6 text-gold-300">
              Navegação
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-brown-200 hover:text-gold-300 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Support & Social */}
          <div>
            <h4 className="text-lg font-display font-semibold mb-6 text-gold-300">
              Suporte
            </h4>
            <ul className="space-y-3 mb-8">
              {supportLinks.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-brown-200 hover:text-gold-300 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>

            {/* Social Links */}
            <div>
              <h5 className="text-md font-semibold mb-4 text-gold-300">
                Siga-nos
              </h5>
              <div className="flex space-x-4">
                {socialLinks.map((social, index) => (
                  <a
                    key={index}
                    href={social.href}
                    aria-label={social.label}
                    className="w-10 h-10 bg-brown-700 rounded-full flex items-center justify-center text-brown-200 hover:bg-gold-600 hover:text-white transition-colors"
                  >
                    <social.icon className="w-5 h-5" />
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Doctrine Statement */}
      <div className="border-t border-brown-700">
        <div className="container mx-auto px-4 py-8">
          <div className="bg-brown-700 rounded-xl p-6 mb-8">
            <div className="flex items-start space-x-3">
              <div className="flex-shrink-0 mt-1">
                <div className="w-8 h-8 bg-gold-500 rounded-full flex items-center justify-center">
                  <span className="text-white text-lg">✝</span>
                </div>
              </div>
              <div>
                <h4 className="text-lg font-display font-semibold mb-3 text-gold-300">
                  Compromisso com a Doutrina Católica
                </h4>
                <p className="text-brown-200 text-sm leading-relaxed">
                  Todo o conteúdo do SantoGram é desenvolvido em conformidade com o Catecismo da Igreja Católica, 
                  as Sagradas Escrituras e o Magistério da Igreja. Nosso aplicativo é uma ferramenta de evangelização 
                  que busca promover a autêntica espiritualidade católica e o crescimento na santidade.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-brown-700">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-brown-300">
            <div className="flex items-center space-x-2 mb-4 md:mb-0">
              <span>© {currentYear} SantoGram. Todos os direitos reservados.</span>
            </div>
            <div className="flex items-center space-x-2">
              <span>Feito com</span>
              <Heart className="w-4 h-4 text-red-400" />
              <span>para a maior glória de Deus</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 